<script>

import moment from "moment";

export default {
    name: "DateOnlyPicker",
    props: {
        id: {
            type: String,
            required: true
        },
        name: {
            type: String,
        },
        isRequired: {
            type: Boolean,
        },
        value: {
            required: true,
            default() {
                return moment();
            }
        },
        format: {
            type: String,
            default() {
                return "YYYY/MM/DD"
            }
        },
        classList: {
            type: Array,
            default() {
                let list = []

                if (this.isRequired)
                    list.push("required")

                return list
            }
        }
    },
    data() {
        return {
            date: this.value,
            moment: moment(this.value, this.format),
            classes: [
                "input-group-new-design",
                "text_input",
                "form-control",
                "only-picker-date",
                ...this.classList
            ]
        }
    },
    mounted() {
        $(this.$refs.datepicker).datepicker({
            format: this.format,
            todayBtn: "linked",
            todayHighlight: true,
            keyboardNavigation: false,
            forceParse: false,
            calendarWeeks: true,
            autoclose: true,
        })
        $(this.$refs.datepicker).datepicker("setDate", this.date)
        $(this.$refs.datepicker).on('change', (e) => {
            this.date = e.target.value;
            this.moment = moment(this.date, this.format);
        });
    },
    watch: {
        value(value) {
            this.date = value
            $(this.$refs.datepicker).datepicker("setDate", this.date)
        },
        date(value) {
            this.$emit('input', value)
        },
        deep: true,
        immediate: true
    }
}
</script>

<template>
    <div>
        <div ref="datepicker" class="input-group date datepicker new-design-parent">
            <input readonly  v-model="date" :id="id" :name="name" type="text"
                   :class="classes.join(' ')" placeholder="Date"/>
            <span class="input-group-addon input-group-addon-new-design"><i
                class="fa fa-calendar"></i></span>
        </div>
        <label :for="id" generated="true" class="error"></label>
    </div>
</template>

<style scoped>
.appointment-ibox-style .datepicker{
    padding: 0 !important;
}
</style>